module.exports = __webpack_public_path__ + "static/media/OilChangeGroup.871cc765.svg";